import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 1,
  class: "n-select__label control-m"
}
const _hoisted_3 = { class: "n-select__content" }
const _hoisted_4 = {
  key: 0,
  class: "n-select__placeholder"
}
const _hoisted_5 = {
  key: 0,
  class: "n-select__icon"
}
const _hoisted_6 = { class: "n-select__icons" }
const _hoisted_7 = ["data-qa"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "n-select__clear-icon" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["data-qa"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "n-select__close-icon" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NIcon = _resolveComponent("NIcon")!
  const _component_NSelectTags = _resolveComponent("NSelectTags")!
  const _component_NSelectTagsCount = _resolveComponent("NSelectTagsCount")!
  const _component_NInputBase = _resolveComponent("NInputBase")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NSelectItems = _resolveComponent("NSelectItems")!
  const _directive_click_outside = _resolveDirective("click-outside")!
  const _directive_stick = _resolveDirective("stick")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      ref: "target",
      tabindex: "0",
      class: _normalizeClass(['n-select', { plain: _ctx.plain, readonly: _ctx.readonly, disabled: _ctx.disabled, multiline: _ctx.multiline, label: _ctx.label, 'value-not-empty': _ctx.isValueNotEmpty }]),
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.focusHandler && _ctx.focusHandler(...args))),
      "data-qa": _ctx.dataQa
    }, [
      (_ctx.prefixIcon)
        ? (_openBlock(), _createBlock(_component_NIcon, {
            key: 0,
            class: "n-select__prefix-icon",
            name: _ctx.prefixIcon,
            width: "16",
            height: "16"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.modelValueArray.length && !_ctx.showInputField && _ctx.formattedPlaceholder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.formattedPlaceholder), 1))
          : _createCommentVNode("", true),
        (_ctx.multiple)
          ? (_openBlock(), _createBlock(_component_NSelectTags, {
              key: 1,
              modelValue: _ctx.modelValueArray,
              multiline: _ctx.multiline,
              collapsed: _ctx.collapsedTags,
              onClose: _ctx.closeTagHandler,
              onHiddenCountChange: _ctx.hiddenCountChange,
              closeable: "",
              "data-qa": _ctx.dataQa
            }, null, 8, ["modelValue", "multiline", "collapsed", "onClose", "onHiddenCountChange", "data-qa"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_ctx.icon)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_NIcon, {
                      width: "16",
                      height: "16",
                      name: _ctx.icon
                    }, null, 8, ["name"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.color)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "n-select__color",
                    style: _normalizeStyle({ backgroundColor: _ctx.color })
                  }, null, 4))
                : _createCommentVNode("", true)
            ], 64)),
        (_ctx.hiddenCount)
          ? (_openBlock(), _createBlock(_component_NSelectTagsCount, {
              key: 3,
              counterValue: _ctx.collapsedTags ? _ctx.hiddenCount : 0,
              onClick: _ctx.tagsCountClickHandler
            }, null, 8, ["counterValue", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.showInputField)
          ? (_openBlock(), _createBlock(_component_NInputBase, {
              key: 4,
              ref: "input",
              modelValue: _ctx.inputValue,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
                _ctx.inputHandler
              ],
              placeholder: _ctx.formattedPlaceholder,
              readonly: _ctx.readonly || _ctx.selectonly,
              "data-qa": `${_ctx.dataQa}.input`,
              onKeydown: _ctx.keydownHandler
            }, null, 8, ["modelValue", "placeholder", "readonly", "data-qa", "onUpdate:modelValue", "onKeydown"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.chevron)
          ? (_openBlock(), _createBlock(_component_NButton, {
              key: 0,
              icon: _ctx.chevron,
              type: "text",
              onClick: _withModifiers(_ctx.toggleHelper, ["stop"]),
              "data-qa": `${_ctx.dataQa}.toggle`
            }, null, 8, ["icon", "onClick", "data-qa"]))
          : _createCommentVNode("", true),
        (_ctx.clearIconVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "n-select__clear-wrapper",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearHandler && _ctx.clearHandler(...args))),
              "data-qa": `${_ctx.dataQa}.clear`
            }, _hoisted_9, 8, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.closeIcon)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "n-select__close-wrapper",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeHandler && _ctx.closeHandler(...args))),
              "data-qa": `${_ctx.dataQa}.close`
            }, _hoisted_12, 8, _hoisted_10))
          : _createCommentVNode("", true)
      ])
    ], 10, _hoisted_1)), [
      [_directive_click_outside, _ctx.closeByOutsideExtended]
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: _ctx.teleportTo }, [
      (_ctx.helperExpanded)
        ? _withDirectives((_openBlock(), _createBlock(_component_NSelectItems, {
            ref: "helper",
            class: "n-picker-helper",
            key: _ctx.itemsHashKey,
            items: _ctx.helperItems,
            multiple: _ctx.multiple,
            "data-qa": _ctx.dataQa,
            capitalizeLabels: _ctx.capitalizeLabels,
            style: _normalizeStyle(_ctx.itemsStyle),
            "show-tooltip": _ctx.showTooltip,
            onSelect: _ctx.selectHandler
          }, null, 8, ["items", "multiple", "data-qa", "capitalizeLabels", "style", "show-tooltip", "onSelect"])), [
            [_directive_stick, _ctx.$refs.target],
            [_directive_click_outside, _ctx.closeByOutside]
          ])
        : _createCommentVNode("", true)
    ], 8, ["to"]))
  ], 64))
}